import PropTypes from 'prop-types';
import React from 'react';
import Dependency from '~/components/AssetDetail/Dependency';
import styles from './DependencyList.css';

const DependencyList = ({
  showDependencyList,
  dependencies,
  onDependencyClick
}) => {
  if (!showDependencyList) {
    return null;
  }

  return (
    <section
      className={styles.dependencyList}
      data-test-id="asset-dependency-list"
      aria-labelledby="dependencies-heading"
    >
      <h4 id="dependencies-heading">Dependencies</h4>
      <div data-test-id="card-dependency-list">
        {dependencies.map((dependency, index) => (
          <Dependency
            key={index}
            asset={dependency}
            onDependencyClick={onDependencyClick}
          />
        ))}
      </div>
    </section>
  );
};

DependencyList.propTypes = {
  dependencies: PropTypes.arrayOf(PropTypes.object),
  showDependencyList: PropTypes.bool,
  onDependencyClick: PropTypes.func
};

DependencyList.defaultProps = {
  showDependencyList: true,
  onDependencyClick: () => {}
};

export default DependencyList;
